import { Helmet } from "react-helmet-async";

interface SEOMetadataProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

export function SEOMetadata({
  title = "Vewly - Your Media. Reimagined.",
  description = "Self-hosted streaming platform with enterprise features. Stream your media anywhere, anytime, on any device. 4K streaming with Pro Pass. Start your 7-day free trial today.",
  image = "https://vewly.app/og-image.jpg",
  url = "https://vewly.app",
  type = "website"
}: SEOMetadataProps) {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Vewly",
    "applicationCategory": "MultimediaApplication",
    "operatingSystem": "Web, iOS, Android, Desktop",
    "description": description,
    "offers": [
      {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "name": "Freemium",
        "description": "7-day trial with 2 hours/day streaming, 1080p playback"
      },
      {
        "@type": "Offer",
        "price": "7.99",
        "priceCurrency": "USD",
        "name": "Pro Pass",
        "description": "Unlimited streaming, 4K+ quality, hardware transcoding"
      },
      {
        "@type": "Offer",
        "price": "299",
        "priceCurrency": "USD",
        "name": "Lifetime Pass",
        "description": "One-time payment for lifetime Pro Pass access"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "500"
    },
    "features": [
      "4K Streaming",
      "Self-Hosted",
      "Cross-Device Sync",
      "AI Content Discovery",
      "WebAuthn MFA",
      "Hardware Transcoding",
      "Plugin Marketplace"
    ]
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Preconnect hints for performance */}
      <link rel="preconnect" href="https://phqugynpzmlqsayoqvhe.supabase.co" />
      <link rel="dns-prefetch" href="https://phqugynpzmlqsayoqvhe.supabase.co" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
